import type { EngineError } from '#layers/base/types/error';
import { defineStore } from 'pinia';
import { readonly, ref } from 'vue';

export const useErrorStore = defineStore('error', () => {
	const globalError = ref<Error | EngineError | null>(null);

	return {
		globalError: readonly(globalError),
		setGlobalError(error: Error | EngineError) {
			return globalError.value = error;
		},
		clearGlobalError: () => globalError.value = null,
	};
});
